import React from "react";
import { Link } from "react-router-dom";
import { FiMenu } from "react-icons/fi";
import useScrollPosition from "../../hooks/useScrollPosition";
import DesktopNavigation from "./DesktopNavigation";
import MobileOffcanvasMenu from "./MobileOffcanvasMenu";
import "./header.css";

/**
 * Header — transparent-over-hero, solid-on-scroll header. Logo left,
 * centered nav, "Plan Your Event" CTA right on desktop; compact bar +
 * offcanvas trigger on mobile.
 */
export default function Header() {
  const { isScrolled } = useScrollPosition(80);

  return (
    <header className={`site-header ${isScrolled ? "is-scrolled" : ""}`}>
      <div className="container-wide site-header-inner">
        <Link to="/" className="site-logo" aria-label="Beejees Convention Centre — home">
          Beejees Convention Centre
        </Link>

        <DesktopNavigation />

        <div className="site-header-actions">
          <Link to="/plan-your-event" className="btn-beejees-primary desktop-only header-cta">
            Plan Your Event
          </Link>
          <button
            className="offcanvas-trigger mobile-only"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#mobileNav"
            aria-controls="mobileNav"
            aria-label="Open menu"
          >
            <FiMenu size={26} />
          </button>
        </div>
      </div>

      <MobileOffcanvasMenu />
    </header>
  );
}
